import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=55d829ce&scoped=true"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentComponent.vue?vue&type=style&index=0&id=55d829ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d829ce",
  null
  
)

export default component.exports